/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { userSchema } from './user-schema';

export const notificationSchema: z.AnyZodObject = z.object({
  body: z.string().nullish(),
  createdAt: z.string().datetime().nullish(),
  emails: z.string().nullish(),
  id: z.string().uuid(),
  isRead: z.boolean().nullish(),
  subject: z.string().nullish(),
  type: z.string().nullish(),
  updatedAt: z.string().datetime().nullish(),
  user: z.lazy(() => userSchema).nullish(),
  userId: z.string().uuid().nullish(),
});

export type Notification = z.infer<typeof notificationSchema>;
